(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-sso-log', {
                parent: 'entity',
                url: '/rcopia-sso-log',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-log/list/rcopia-sso-logs.html',
                        controller: 'RcopiaSsoLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('rcopia-sso-log-detail', {
                parent: 'entity',
                url: '/rcopia-sso-log/{id}',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoLog'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                        controller: 'RcopiaSsoLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'RcopiaSsoLog', function ($stateParams, RcopiaSsoLog) {
                        return RcopiaSsoLog.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'rcopia-sso-log',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();
